import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Modal,
  Stack,
  Loader,
  Text,
  Group,
  ActionIcon,
  Checkbox,
  Center,
  AspectRatio,
  CopyButton,
  Alert,
} from "@mantine/core";
import { Cubby } from "../../stores/Cubby";

import { decode } from "@gandlaf21/bolt11-decode";

import { QRCodeSVG } from "qrcode.react";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import _ from "lodash";
import { convertSatsToFiatString } from "../../helpers/conversions";

const InboundInvoiceQR = observer(({ cubby }: { cubby: Cubby }) => {
  const invoiceString = cubby.channelOfferInvoiceForUserPayment;
  // ("lntb166990n1pnsr8vhpp5euzmh3y99g3znnw5peerufxs2t6sdwq85nsvwcupq9zlfgv4dn6sdphgajhggzfde3x7atwvssyc6t3w45kg6t50ysz6gzjd9axvatv9e3k7mgcqzzsxqr9ghsp5an0306uh44kt77zpnruqpg88r8mgczv8fcyk7nganas72hq9s28s9p4gqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpqysgqdq660unevk82t57dj9qlgnlzgudqznjc3fyyxavk8nzf8lv9zek9525vpvhcdx2t9jv3svtch2fwmw4evk0g66vwcw6ljphuf8zhr9sp2d534x");

  const decodedInvoice = decode(invoiceString);
  //console.log("decoded invoice", decodedInvoice);
  const invoiceValue = decodedInvoice.sections[2].value / 1000;

  console.log("should use this.channelOffers", cubby.channelOffers.data);

  return (
    <>
      <Stack gap="xs">
        <AspectRatio ratio={1}>
          <QRCodeSVG
            value={invoiceString}
            title={"Rizful Invoice For Inbound Channel"}
            size={300}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
            marginSize={6}
          />
        </AspectRatio>

        <Text size="sm" ta="center">
          inbound channel: {invoiceValue.toLocaleString()} satoshis (
          {convertSatsToFiatString(invoiceValue, cubby)})
        </Text>

        <Text size="sm" ta="center">
          pay with any lightning-enabled Bitcoin wallet
        </Text>
        <Center>
          <Group gap="xs" mb="100px">
            <Text ta="center" size="xs">
              {_.truncate(invoiceString, { length: 25 })}
            </Text>
            <CopyButton value={invoiceString}>
              {({ copied, copy }) => (
                <ActionIcon
                  size="lg"
                  variant={copied ? "filled" : "default"}
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  aria-label="copy address"
                >
                  {copied ? <IconCheck /> : <IconCopy />}
                </ActionIcon>
              )}
            </CopyButton>
          </Group>
        </Center>
        {cubby.cubbyNetwork === "testnet" && (
          <Alert>
            This is a testnet invoice, which must be paid with testnet funds.
          </Alert>
        )}
      </Stack>

      {/* <Text> {demoInvoice}</Text> */}
    </>
  );
});

export default InboundInvoiceQR;
